import script from "./SectionShell.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionShell.vue?vue&type=script&setup=true&lang=js"

import "./SectionShell.vue?vue&type=style&index=0&id=4eb03e4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eb03e4c"]])

export default __exports__